<template>
  <div class="hub-activity-rows">
    <button v-for="item in entries" :key="item.id" type="button" class="hub-activity-row" @click="$emit('select', item)">
      <span class="hub-activity-symbol"><v-icon color="#bdbdbd" size="21">{{ item.icon }}</v-icon></span>
      <span class="hub-activity-copy"><strong>{{ item.title }}</strong>
        <span class="hub-activity-meta"><span>{{ dateLabel(item) }} · {{ item.sourceNames.join(' + ') }}</span><span class="hub-activity-duration">{{ duration(item.durationSeconds) }}</span></span>
        <small v-if="item.pendingOverlap" class="hub-overlap-note">Mögliche Doppelung · noch nicht mitgezählt</small>
        <small v-else-if="detailLabel(item)">{{ detailLabel(item) }}</small>
      </span>
      <v-icon small color="#999">mdi-chevron-right</v-icon>
    </button>
  </div>
</template>

<script>
import { hubDuration, hubStatusLabel } from "@/services/customerHubActivityData"
export default {
  props: { entries: { type: Array, default: () => [] }, showDate: { type: Boolean, default: false }, showStatus: { type: Boolean, default: true } },
  methods: {
    duration: hubDuration,
    statusLabel: hubStatusLabel,
    detailLabel(item) {
      return [this.showStatus ? this.statusLabel(item.status) : "", item.durationSource === "course_schedule" ? "Kursplandauer" : "", item.sources.length > 1 && item.status === "completed" ? "einmal gezählt" : ""].filter(Boolean).join(" · ")
    },
    dateLabel(item) {
      const day = this.showDate ? this.$moment(item.date).format("DD.MM.YYYY") : ""
      const time = (item.timeIsExact || item.scheduledTimeIsExact) && item.startedAt
        ? this.$moment(item.startedAt).format("HH:mm") + (!item.timeIsExact ? " laut Kursplan" : "") : "Zeit nicht erfasst"
      return [day, time].filter(Boolean).join(" · ")
    },
  },
}
</script>
<style scoped>
.hub-activity-row { width: 100%; display: flex; align-items: center; gap: 10px; padding: 14px 0; color: #fff; text-align: left; border-bottom: 1px solid #ffffff0e; word-break: normal; overflow-wrap: break-word; }
.hub-activity-symbol { display: grid; place-items: center; background: #ffffff06; border-radius: 11px; flex: 0 0 36px; height: 36px; }
.hub-activity-copy { flex: 1; min-width: 0; }
.hub-activity-copy > strong, .hub-activity-copy > small { display: block; line-height: 1.45; }
.hub-activity-copy > strong { font-size: 15px; }
.hub-activity-meta { display: flex; flex-wrap: wrap; align-items: baseline; gap: 2px 10px; margin-top: 4px; line-height: 1.5; }
.hub-activity-meta > span, .hub-activity-copy > small { font-size: 11px; color: #aaa; }
.hub-activity-duration { white-space: nowrap; }
.hub-activity-copy > small { margin-top: 3px; }.hub-activity-copy .hub-overlap-note { color: #f4c87e; }
.hub-activity-row > .v-icon { flex: 0 0 auto; }
button:focus-visible { outline: 2px solid var(--v-primary-base, #00963f); outline-offset: 3px; }
</style>
